// extracted by mini-css-extract-plugin
export var answer = "faqCategoryQuestion-module--answer--87adb";
export var faqCategoryQuestion = "faqCategoryQuestion-module--faq-category-question--a278b";
export var open = "faqCategoryQuestion-module--open--14e45";
export var question = "faqCategoryQuestion-module--question--07d8d";